import * as React from "react";
import { Popup } from "@progress/kendo-react-popup";
import { toastr } from "react-redux-toastr";
import Api from "../../Services/Api";
import { CircularProgress } from "@material-ui/core";

export default class ReportUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openWidgetCreatePopup: false,
      chartData: {},
      loader: false,
    };
  }
  editWidgetdOpen = (data) => {
    this.setState({
      ...this.state,
      openWidgetCreatePopup: true,
      name: data.widgetName,
      title: data.title,
      description: data.description,
      chartData: data,
    });
  };
  updateReportPopupClose = () => {
    this.setState({
      ...this.state,
      openWidgetCreatePopup: false,
      loader: false,
    });
  };
  updateWidgetDetails = async () => {
    this.setState({
      ...this.state,
      loader: true,
    });
    try {
      var request = {
        WidgetId: this.state.chartData.widgetId,
        name: this.state.name,
        title: this.state.title,
        description: this.state.description,
      };
      let response = await Api.updateWidgetDetails(request);
      if (response.status === 200) {
        this.props.updateChartData(this.state.chartData);
        toastr.success(response.message);
      } else {
        toastr.error(response.message);
        this.setState({
          ...this.state,
          loader: false,
        });
      }
    } catch (err) {
      console.error("Exception:", err);
    }
  };
  render() {
    return (
      <div>
        <Popup
          show={this.state.openWidgetCreatePopup}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="reportsPopup">
            <h3>Update Report</h3>
            <div className="formControl">
              <label>Report Name * </label>
              <input
                type="text"
                value={this.state.name}
                // onBlur={(e) => this.isExistName(e)}
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    name: e.target.value,
                  });
                }}
              />
            </div>
            <div className="formControl">
              <label>Report Title</label>
              <input
                type="text"
                value={this.state.title}
                // onBlur={(e) => this.isExistName(e)}
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    title: e.target.value,
                  });
                }}
              />
            </div>
            <div className="formControl">
              <label>Report Description </label>
              <input
                type="text"
                value={this.state.description}
                // onBlur={(e) => this.isExistName(e)}
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    description: e.target.value,
                  });
                }}
              />
            </div>
            <div className="d-flex justify-content-end">
              <button
                className="btnGreen"
                type="button"
                onClick={this.updateWidgetDetails}
                disabled={!this.state.name?.trim()}
              >
                {"Update Report"}
              </button>
              <button
                className="btnRed"
                type="button"
                onClick={this.updateReportPopupClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
